/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, sets: NonNullable<unknown> }} Wrapped_Muscles_TopInputs */

const en_us2_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.name} led, with 1 set.`);
	return /** @type {LocalizedString} */ (`${i?.name} led, with ${i?.sets} sets.`)
	
};

const pt_br2_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.name} liderou, com 1 série.`);
	return /** @type {LocalizedString} */ (`${i?.name} liderou, com ${i?.sets} séries.`)
	
};

const es_419_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.name} lideró, con 1 serie.`);
	return /** @type {LocalizedString} */ (`${i?.name} lideró, con ${i?.sets} series.`)
	
};

const pt_pt2_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.name} liderou, com 1 série.`);
	return /** @type {LocalizedString} */ (`${i?.name} liderou, com ${i?.sets} séries.`)
	
};

const fr_fr2_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.name} en tête, avec 1 série.`);
	return /** @type {LocalizedString} */ (`${i?.name} en tête, avec ${i?.sets} séries.`)
	
};

const de_de2_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.name} vorne, mit 1 Satz.`);
	return /** @type {LocalizedString} */ (`${i?.name} vorne, mit ${i?.sets} Sätzen.`)
	
};

const it_it2_wrapped_muscles_top = /** @type {(inputs: Wrapped_Muscles_TopInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`In testa ${i?.name}, con 1 serie.`);
	return /** @type {LocalizedString} */ (`In testa ${i?.name}, con ${i?.sets} serie.`)
	
};

/**
* | sets | output |
* | --- | --- |
* | "1" | "{name} led, with 1 set." |
* | * | "{name} led, with {sets} sets." |
*
* @param {Wrapped_Muscles_TopInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_top = /** @type {((inputs: Wrapped_Muscles_TopInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_TopInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_top(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_top(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_top(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_top(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_top(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_top(inputs)
	return en_us2_wrapped_muscles_top(inputs)
});
export { wrapped_muscles_top as "wrapped.muscles_top" }